import script from "./DocumentoEntradaModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentoEntradaModal.vue?vue&type=script&setup=true&lang=js"

import "./DocumentoEntradaModal.vue?vue&type=style&index=0&id=2a222cba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a222cba"]])

export default __exports__